
// Server convention (DualLinkDB weekday(): Calendar.weekday - 1, Sunday first):
// the bit for a date is 1 << weekday, so Sunday = 1. The manager used to store
// Monday-first masks, which the server read shifted by one day.
enum WeekDays {
    Sunday      = 1 << 0,
    Monday      = 1 << 1,
    Tuesdays    = 1 << 2,
    Wednesday   = 1 << 3,
    Thursday    = 1 << 4,
    Friday      = 1 << 5,
    Saturday    = 1 << 6,
}
